<div class="ot_card_border">
  <ion-card class="box {{ type }}" (click)="goToOt()" [attr.data-test]="'ot_card_' + otCardItem.numeroOt">
    <p class="otInfo" style="display: flex; align-items: center; gap: 4px">
      <b>OT {{ otCardItem.numeroOt }}</b>
      ( {{ otCardItem.startTime }} - {{ otCardItem.endTime }} )
      @if (otCardItem.presence_document) {
        <ion-icon name="attach-outline" slot="end"></ion-icon>
      }
    </p>
    <p class="libelle-otCard otInfo">{{ otCardItem.libelleOt }}</p>
  </ion-card>
  <ion-card class="box  detailOtCard {{ type }}-border">
    <div class="detail_left">
      <ion-item>
        @if (otCardItem.has_echapetbelle) {
          <ion-icon class="ion-align-self-center" size="small" name="echapetbelle" slot="start" />
        }
        @if (otCardItem.est_rdv_client) {
          <ion-icon
            class="ion-align-self-center"
            size="small"
            color="medium"
            name="today-outline"
            slot="start"
          ></ion-icon>
        }
        @if (otCardItem.est_controle_reglementaire) {
          <ion-icon
            class="ion-align-self-center"
            size="small"
            color="medium"
            name="agenda-controle-reglementaire"
            slot="start"
          ></ion-icon>
        }
        @if (hasActiviteEnPause$ | async) {
          <ion-icon
            class="ion-align-self-center"
            size="small"
            color="medium"
            name="hourglass-outline"
            slot="start"
          ></ion-icon>
        }
        @if (hasGeolocConsent()) {
          <ion-label class="libelle-site" slot="start">{{ otCardItem.site }}</ion-label>
          @if (hasActiviteEncours()) {
            <ion-button expand="block" color="danger" slot="end" class="start-btn no-click" size="small" disabled>
              <ion-label slot="start">{{ etatActivite() }}</ion-label>
            </ion-button>
          } @else if (hasActiviteEnPause$ | async) {
            <ion-button expand="block" (click)="startOt()" color="danger" slot="end" class="start-btn" size="small">
              <ion-label slot="start">Reprendre</ion-label>
              <ion-icon slot="end" name="play" size="small"></ion-icon>
            </ion-button>
          } @else {
            <ion-button expand="block" (click)="startOt()" color="danger" slot="end" class="start-btn" size="small">
              <ion-label slot="start">Démarrer</ion-label>
              <ion-icon slot="end" name="play" size="small"></ion-icon>
            </ion-button>
          }
        } @else {
          <ion-label class="libelle-site">{{ otCardItem.site }}</ion-label>
        }
      </ion-item>
    </div>
  </ion-card>
</div>
